import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

function FeaturedTable() {
	const rows = [
		{
			id: 1143155,
			username: "jsmith",
			img: "https://m.media-amazon.com/images/I/81bc8mA3nKL._AC_UY327_FMwebp_QL65_.jpg",
			firstname: "John",
			lastname: "Smith",
			email: "jsmith@gmail.com",
			date: "1 March",
			county: "Nyeri",
		},
		{
			id: 2235235,
			username: "michaeld",
			img: "https://m.media-amazon.com/images/I/31JaiPXYI8L._AC_UY327_FMwebp_QL65_.jpg",
			firstname: "Michael",
			lastname: "Doe",
			email: "doe67@gmail.com",
			date: "1 March",
			county: "Nairobi",
		},
		{
			id: 2342353,
			username: "smithy",
			img: "https://m.media-amazon.com/images/I/71kr3WAj1FL._AC_UY327_FMwebp_QL65_.jpg",
			firstname: "John",
			lastname: "Smith",
			email: "smithy324@gmail.com",
			date: "1 March",
			county: "Bungoma",
		},
		{
			id: 2357741,
			username: "Janesmt",
			img: "https://m.media-amazon.com/images/I/71wF7YDIQkL._AC_UY327_FMwebp_QL65_.jpg",
			firstname: "Jane",
			lastname: "Smith",
			email: "janesmth@gmail.com",
			date: "1 March",
			county: "Mandera",
		},
		{
			id: 2342355,
			username: "carolhrld",
			img: "https://m.media-amazon.com/images/I/81hH5vK-MCL._AC_UY327_FMwebp_QL65_.jpg",
			firstname: "Harold",
			lastname: "Carol",
			email: "hrldcarol@gmail.com",
			date: "1 March",
			county: "Kiambu",
		},
	];

	return (
		<div className="mt-4 border border-slate-100 dark:border-darkborder bg-white dark:bg-darkbg rounded-md shadow-sm px-5 py-2">
			<h1 className="text-slate-500">Latest Users</h1>
			<TableContainer component={Paper} className="dark:bg-darkbg">
				<Table sx={{ minWidth: 650 }} aria-label="simple table">
					<TableHead>
						<TableRow>
							<TableCell className="dark:text-darktext">ID</TableCell>
							<TableCell className="dark:text-darktext">Username</TableCell>
							<TableCell className="dark:text-darktext">First Name</TableCell>
							<TableCell className="dark:text-darktext">Last Name</TableCell>
							<TableCell className="dark:text-darktext">Email</TableCell>
							<TableCell className="dark:text-darktext">Date</TableCell>
							<TableCell className="dark:text-darktext">County</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{rows.map((row) => (
							<TableRow key={row.id}>
								<TableCell className="dark:text-darktext">
									<span className="before:content-['#']">{row.id}</span>
								</TableCell>
								<TableCell className="dark:text-darktext">
									<div className="flex">
										<img
											src={row.img}
											alt="image"
											className="w-6 h-6 rounded-full object-cover mr-2"
										/>
										{row.username}
									</div>
								</TableCell>
								<TableCell className="dark:text-darktext">
									{row.firstname}
								</TableCell>
								<TableCell className="dark:text-darktext">
									<span className="">{row.lastname}</span>
								</TableCell>
								<TableCell className="dark:text-darktext">
									{row.email}
								</TableCell>
								<TableCell className="dark:text-darktext">{row.date}</TableCell>
								<TableCell className="dark:text-darktext">
									<span className={`status ${row.county}`}>{row.county}</span>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</div>
	);
}

export default FeaturedTable;
